<template>
  <div>
    <!-- <div class="account-card"> -->
    <div style="display: flex; align-items: center">
      <h2
        class="account-card-title"
        data-test="payment-methods-title"
      >
        Payment Methods
      </h2>
    </div>
    <Card class="account-card-info card-style">
      <template #content>
        <div
          class="weight-600"
          data-test="active-payment-methods-title"
        >
          ACTIVE PAYMENT METHODS
        </div>
        <div
          v-for="(profile, index) in donorStore.paymentProfiles.filter((profile) => profile.inactive != 1)"
          :key="index"
          class="field-title"
          style="width: 100%"
          data-test="active-payment-method"
        >
          <div
            class="flex"
            style="justify-content: space-between; align-items: flex-end"
          >
            <div style="width: 100%; padding-right: 24px">
              <div>
                {{ profile.profileName + ' - ' + (profile.paymentType == 5564 ? 'Credit Card' : 'Bank Account') }}
              </div>
              <div class="card-info font-16 weight-500">
                <div
                  v-if="profile.last4 != null"
                  class="flex"
                >
                  <img
                    v-if="profile.processingInfo_brand != null || profile.paymentType == 5565"
                    style="padding-right: 5px"
                    :src="profile.paymentType == 5565 ? ACH : paymentImageSource(profile.processingInfo_brand)"
                    :alt="profile.paymentType == 5565 ? 'ACH' : profile.processingInfo_brand"
                  />{{ 'Ending In ' + profile.last4 }}
                </div>
                <div v-if="profile.expirationDateMonth != null && profile.expirationDateYear != null">
                  Exp {{ profile.expirationDateMonth + '/' + profile.expirationDateYear }}
                </div>
              </div>
            </div>
            <div>
              <img
                :class="{
                  'cursor-pointer': !deactivateDisabled,
                  'opacity-50': deactivateDisabled,
                }"
                :style="{ pointerEvents: deactivateDisabled ? 'none' : 'auto' }"
                @click="!deactivateDisabled && showDeactivatePaymentMethodModal(profile)"
                :src="Trashcan"
                style="padding-bottom: 7px"
                data-test="deactivate-button"
              />
            </div>
          </div>
        </div>
        <div
          @click="toggleAccordion()"
          class="weight-600 cursor-pointer flex"
          v-if="donorStore.paymentProfiles.filter((profile) => profile.inactive == 1).length > 0"
          data-test="inactive-payment-methods-toggle"
        >
          INACTIVE PAYMENT METHODS ({{ donorStore.paymentProfiles.filter((profile) => profile.inactive == 1).length }})
          <img
            class="cursor-pointer"
            :src="ChevronDownDark"
            style="padding-left: 7px"
          />
        </div>
        <div
          v-if="showInactivePaymentMethods"
          class="field-title"
          style="width: 100%"
          data-test="inactive-payment-methods"
        >
          <div
            v-for="(profile, index) in donorStore.paymentProfiles.filter((profile) => profile.inactive == 1)"
            :key="index"
            class="field-title"
            style="width: 100%"
            data-test="inactive-payment-method"
          >
            <div
              class="flex"
              style="justify-content: space-between; align-items: flex-end"
            >
              <div style="width: 100%; padding-right: 24px">
                <div>
                  {{ profile.profileName + ' - ' + (profile.paymentType == 5564 ? 'Credit Card' : 'Bank Account') }}
                </div>
                <div class="card-info font-16 weight-500">
                  <div
                    v-if="profile.last4 != null"
                    class="flex"
                  >
                    <img
                      v-if="profile.processingInfo_brand != null || profile.paymentType == 5565"
                      style="padding-right: 5px"
                      :src="profile.paymentType == 5565 ? ACH : paymentImageSource(profile.processingInfo_brand)"
                      :alt="profile.paymentType == 5565 ? 'ACH' : profile.processingInfo_brand"
                    />{{ 'Ending In ' + profile.last4 }}
                  </div>
                  <div v-if="profile.expirationDateMonth != null && profile.expirationDateYear != null">
                    Exp {{ profile.expirationDateMonth + '/' + profile.expirationDateYear }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <neon-udf
          :form-id="donorStore.formId"
          :color="donorStore.mainColor"
          :button-text-color="getContrastYIQ(donorStore.mainColor)"
          button-size="large"
          mode="prod"
          payment-processor="payrix"
          button-text="New Payment Method"
          page="newPayment"
          :email="donorStore.donorInfo.email"
          :donor-account-id="donorStore.donorAccounts_id"
          data-test="new-payment-method-button"
        ></neon-udf>
      </template>
    </Card>
    <!-- </div> -->
    <Modal
      :show="donorStore.showDeactivatePaymentMethod"
      @close="
        donorStore.showDeactivatePaymentMethod = false;
        donorStore.errorMessage = '';
        donorStore.errorOccurred = false;
      "
      data-test="deactivate-payment-method-modal"
    >
      <template #header>Deactivate Payment Method</template>
      <div class="flex w-full flex-col">
        <div class="removeFavoriteTextContainer">
          <p
            v-if="donorStore.errorOccurred"
            class="error-message"
            data-test="error-message"
          >
            {{ donorStore.errorMessage }}
          </p>
          <p>Are you sure you would like to deactivate this payment method?</p>
        </div>
        <div class="flex justify-between items-start pt-8">
          <div
            class="flex justify-between items-start flex-col"
            style="width: 100%; padding-right: 24px"
          >
            <div>
              {{ currentProfile.paymentType == 5564 ? 'Credit Card' : 'Bank Account' }}
            </div>
            <div class="flex justify-between font-16 weight-500 w-[300px] flex-row">
              <div
                v-if="currentProfile.last4 != null"
                class="flex"
              >
                <img
                  v-if="currentProfile.processingInfo_brand != null || currentProfile.paymentType == 5565"
                  style="padding-right: 5px"
                  :src="
                    currentProfile.paymentType == 5565 ? ACH : paymentImageSource(currentProfile.processingInfo_brand)
                  "
                  :alt="currentProfile.paymentType == 5565 ? 'ACH' : currentProfile.processingInfo_brand"
                />{{ 'Ending In ' + currentProfile.last4 }}
              </div>
              <div v-if="currentProfile.expirationDateMonth != null && currentProfile.expirationDateYear != null">
                Exp {{ currentProfile.expirationDateMonth + '/' + currentProfile.expirationDateYear }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <template #footer>
        <Button
          class="p-button-text"
          :style="{ color: donorStore.mainColor }"
          @click="
            donorStore.showDeactivatePaymentMethod = false;
            donorStore.errorMessage = '';
            donorStore.errorOccurred = false;
          "
          data-test="cancel-deactivate-button"
        >
          Cancel
        </Button>
        <Button
          class="p-button"
          :style="{ color: getContrastYIQ(donorStore.mainColor) }"
          :loading="isLoading"
          @click="deactivateAndRemovePaymentMethod(currentProfile.donorAccounts_paymentProfiles_id)"
          data-test="confirm-deactivate-button"
        >
          Confirm
        </Button>
      </template>
    </Modal>
    <Modal
      height="718px"
      :show="donorStore.showDeactivateRecurringPaymentMethod"
      @close="
        donorStore.showDeactivateRecurringPaymentMethod = false;
        donorStore.errorMessage = '';
        donorStore.errorOccurred = false;
      "
    >
      <template #header>Deactivate Payment Method</template>
      <div
        class="flex overflow-y-scroll scrollbar recurring-heigth"
        style="flex-direction: column; align-items: flex-start; color: #000"
      >
        <p class="removeFavoriteTextContainer pb-4">Are you sure you would like to deactivate this payment method?</p>
        <p>
          This payment method is used for the following recurring donations, a new payment method must be selected for
          these donations in order to proceed:
        </p>

        <div
          style="width: 100%"
          v-for="donation in filteredDonations"
          :key="donation.recurringDonations_id"
        >
          <div class="donation-container">
            <div>
              <div class="donation-details">
                <div class="amount">{{ filters.formatMoney(donation.amount_manual) }}</div>
                <div class="frequency">
                  <div>{{ mapRecurEvery(donation.recurEvery) }}</div>
                  <div>{{ filters.formatDate(donation.enteredDate) }}</div>
                </div>
              </div>

              <div class="orgName">{{ donation.organizationName }}</div>
            </div>
            <div class="dropdown-container">
              <label for="profileName">New Payment Method</label>
              <Dropdown
                class="p-dropdown"
                style="text-align: left"
                placeholder="Select Payment"
                :options="availableProfiles"
                optionLabel="profileName"
                inputId="profileName"
                optionValue="donorAccounts_paymentProfiles_id"
                @change="handleSelection(donation.recurringDonations_id, $event.value)"
              />
            </div>
          </div>
        </div>
      </div>
      <template #footer>
        <Button
          class="p-button-text"
          @click="donorStore.showDeactivateRecurringPaymentMethod = false"
        >
          Cancel
        </Button>
        <Button
          class="p-button"
          :style="{ color: getContrastYIQ(donorStore.mainColor) }"
          :disabled="!allSelectionsMade"
          :loading="isLoading"
          @click="deactivateAndRemovePaymentMethod(true)"
        >
          Confirm
        </Button>
      </template>
    </Modal>
  </div>
</template>

<script setup>
import { ref, onMounted, computed, watch } from 'vue';
import filters from '@/helpers/filters';
import { useDonorStore } from '@/stores/DonorStore.js';
import Trashcan from '@/assets/Trashcan.svg';
import Modal from '@/components/Modal.vue';
import { useEventsStore } from '@/stores/EventsStore.js';
import Mastercard from '@/assets/Mastercard.svg';
import Visa from '@/assets/Visa.svg';
import Discover from '@/assets/Discover.svg';
import Amex from '@/assets/Amex.svg';
import ACH from '@/assets/ACH.svg';
import ChevronDownDark from '@/assets/ChevronDownDark.svg';
import getContrastYIQ from '@/helpers/getContrastYIQ';

const donorStore = useDonorStore();

const mainColor = donorStore.mainColor;

const filteredDonations = computed(() => {
  if (!currentProfile.value || !currentProfile.value.donorAccounts_paymentProfiles_id) {
    return [];
  }
  return donorStore.activeRecurring.filter(
    (donation) => donation.donorAccounts_paymentProfiles_id === currentProfile.value.donorAccounts_paymentProfiles_id,
  );
});

const recurringDonationNewPaymentAssignment = ref([]);

const recurringDonations = ref([]);

const currentProfile = ref({});

const availableProfiles = ref({});

const selections = ref({});

function handleSelection(donationId, profileId) {
  selections.value[donationId] = profileId;
  getPairsOfNewDonationAndNewPaymentMethod(donationId, profileId);
}

const allSelectionsMade = computed(() => {
  const requiredDonationIds = filteredDonations.value.map((donation) => donation.recurringDonations_id);

  const allSelected = requiredDonationIds.every((id) => {
    return selections.value[id] !== undefined;
  });

  return allSelected;
});

const recurEveryMap = computed(() => ({
  914: 'Weekly',
  915: 'Monthly',
  916: 'Quarterly',
  917: 'Yearly',
}));

const mapRecurEvery = (id) => {
  return recurEveryMap.value[id] || 'Unknown';
};

const paymentImageSource = (type) => {
  switch (type) {
    case 'Visa':
      return Visa;
    case 'Checking Account':
      return ACH;
    case 'MasterCard':
      return Mastercard;
    case 'American Express':
      return Amex;
    case 'Amex':
      return Amex;
    case 'Discover':
      return Discover;
    default:
      return '';
  }
};
const showInactivePaymentMethods = ref(false); // Add a boolean ref

function toggleAccordion() {
  showInactivePaymentMethods.value = !showInactivePaymentMethods.value; // Toggle the boolean value
}
// PAYMENT METHODS FUNCTIONS
useEventsStore().subscribeToEvent('paymentProfileSaved', (data) => donorStore.addPaymentMethod(data));

const showDeactivatePaymentMethodModal = async (profile) => {
  currentProfile.value = profile;

  availableProfiles.value = donorStore.paymentProfiles.filter(
    (profile) =>
      profile.donorAccounts_paymentProfiles_id !== currentProfile.value.donorAccounts_paymentProfiles_id &&
      profile.inactive !== 1,
  );

  if (profile.hasRecurringDonation) {
    donorStore.showDeactivateRecurringPaymentMethod = true;
  } else {
    donorStore.showDeactivatePaymentMethod = true;
    return;
  }

  // Handle single ID or array of IDs
  let recurringDonationIds = Array.isArray(profile.recurringDonationId)
    ? profile.recurringDonationId
    : [profile.recurringDonationId];

  recurringDonations.value = recurringDonationIds;

  const recurringDonationNewPaymentAssignmentArray = [];

  recurringDonationIds.forEach((donation) => {
    const paymentProfile = donorStore.paymentProfiles.find((profile) => profile !== currentProfile);
    const paymentProfileId = paymentProfile?.donorAccounts_paymentProfiles_id;

    // Add the object to the array
    recurringDonationNewPaymentAssignmentArray.push({
      recurringDonationId: donation,
      paymentProfile: paymentProfileId,
    });
  });

  // Set recurringDonationNewPaymentAssignment to the array
  recurringDonationNewPaymentAssignment.value = recurringDonationNewPaymentAssignmentArray;
};

const getPairsOfNewDonationAndNewPaymentMethod = (transactionId, paymentProfile) => {
  // Find the index of the object in recurringDonationNewPaymentAssignment with the matching transactionId
  const indexToUpdate = recurringDonationNewPaymentAssignment.value.findIndex(
    (pair) => pair.recurringDonationId === transactionId,
  );

  // If the index is found, update the paymentProfile
  if (indexToUpdate !== -1) {
    recurringDonationNewPaymentAssignment.value[indexToUpdate].paymentProfile = paymentProfile;
  } else {
    // Optionally handle the case where no matching donation is found
    console.warn(`No matching donation found for transaction ID ${transactionId}`);
  }
};

const isLoading = ref(false);

const deactivateAndRemovePaymentMethod = async (hasRecurring = false) => {
  isLoading.value = true; // Set loading to true when starting

  try {
    let paymentProfileId = currentProfile.value.donorAccounts_paymentProfiles_id;
    let result = await donorStore.deactivatePaymentMethod(paymentProfileId);

    if (hasRecurring) {
      recurringDonationNewPaymentAssignment.value.forEach((pair) => {
        if (pair.paymentProfile === paymentProfileId) {
          pair.paymentProfile =
            donorStore.paymentProfiles.find(
              (profile) => profile.donorAccounts_paymentProfiles_id !== paymentProfileId && !profile.inactive,
            )?.donorAccounts_paymentProfiles_id || null;
        }
      });

      donorStore.updateRecurringTransactions(recurringDonationNewPaymentAssignment.value);
      donorStore.showDeactivateRecurringPaymentMethod = false;
    }

    if (result) {
      donorStore.paymentProfiles = donorStore.paymentProfiles.map((profile) => {
        if (profile.donorAccounts_paymentProfiles_id === paymentProfileId) {
          return {
            ...profile,
            inactive: 1,
          };
        }
        return profile;
      });
    }
  } catch (error) {
    console.error('Error deactivating payment method:', error);
  } finally {
    donorStore.fetchDonorPaymentProfiles();
    isLoading.value = false; // Ensure loading is set to false when done
  }
};

// Check if deactivation is possible
const canDeactivate = computed(() => {
  const activeProfiles = donorStore.paymentProfiles.filter((profile) => profile.inactive !== 1);

  // If there is more than one active profile, deactivation is allowed
  if (activeProfiles.length > 1) {
    return true;
  }

  // If there is only one active profile, check if it has any recurring donations
  if (activeProfiles.length === 1) {
    return !activeProfiles[0].hasRecurringDonation;
  }

  // If there are no active profiles, deactivation is not allowed
  return false;
});

const deactivateDisabled = computed(() => !canDeactivate.value);

onMounted(() => {
  donorStore.fetchRecurringDonations();
  donorStore.fetchDonorPaymentProfiles();
});

watch(
  () => currentProfile.value,
  () => {
    // Recompute or fetch filtered donations when current profile changes
    donorStore.fetchRecurringDonations();
  },
);
</script>
<style lang="scss">
.donation-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 20px 0;
  flex-wrap: wrap; /* Allow wrapping of child elements */
}

.donation-details {
  display: flex;
  flex-direction: row; /* Default to row for desktop */
  align-items: flex-start;
  flex: 1; /* Allow it to grow and take available space */
  justify-content: space-between;
}
.amount {
  width: auto; /* Remove fixed width */
  flex-shrink: 0;
  color: #000;
  font-family: Poppins;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 140%;
  display: flex;
  align-items: flex-start;
  margin-right: 20px; /* Adjust spacing as needed */
}
.frequency {
  color: #000;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.orgName {
  color: #000;
  width: 250px;
  overflow: hidden;
  font-feature-settings: 'liga' off, 'clig' off;
  text-overflow: ellipsis;
  font-family: Poppins;
  font-size: 14px;
  text-align: left;
  margin-top: 10px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-height: 1.2rem;
  max-height: 2.4rem;
}
.dropdown-container {
  flex-shrink: 0; /* Prevent shrinking */
  display: flex;
  flex-direction: column;
}
.donation-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 20px 0;
  flex-wrap: wrap; /* Allow wrapping of child elements */
}

.donation-details {
  display: flex;
  flex-direction: row; /* Default to row for desktop */
  align-items: flex-start;
  flex: 1; /* Allow it to grow and take available space */
  justify-content: space-between;
}
.amount {
  width: auto; /* Remove fixed width */
  flex-shrink: 0;
  color: #000;
  font-family: Poppins;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 140%;
  display: flex;
  align-items: flex-start;
  margin-right: 20px; /* Adjust spacing as needed */
}
.frequency {
  color: #000;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.orgName {
  color: #000;
  width: 250px;
  overflow: hidden;
  font-feature-settings: 'liga' off, 'clig' off;
  text-overflow: ellipsis;
  font-family: Poppins;
  font-size: 14px;
  text-align: left;
  margin-top: 10px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-height: 1.2rem;
  max-height: 2.4rem;
}
.dropdown-container {
  flex-shrink: 0; /* Prevent shrinking */
}
.field-title {
  color: #000;
  text-align: center;
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-align: left;
}
.field {
  text-align: left;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.card-info {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}
.recurring-heigth {
  height: 420px;
}
.removeFavoriteTextContainer {
  max-width: 470px;
  font-weight: 500;
  font-size: 1.625rem;
  text-align: left;
}
@media screen and (max-width: 768px) {
  .removeFavoriteTextContainer {
    font-size: 1.25rem;
  }
  .recurring-heigth {
    height: 460px;
  }
}
@media screen and (max-width: 530px) {
  .card-info {
    flex-direction: column;
  }
}

@media (max-width: 768px) {
  .donation-container {
    flex-direction: column;
  }

  .donation-details {
    flex-direction: row; /* Change to row for mobile */
    align-items: center;
  }

  .frequency {
    margin-left: auto; /* Push frequency to the far right */
    margin-top: 0; /* Remove top margin */
  }

  .orgName {
    width: 286px; /* Restore width for mobile */
    margin-top: 0; /* Remove top margin for mobile */
  }

  .dropdown-container {
    padding-top: 20px;
  }
}

@media (max-width: 768px) {
  .donation-container {
    flex-direction: column;
  }

  .donation-details {
    flex-direction: row; /* Change to row for mobile */
    align-items: center;
  }

  .frequency {
    margin-left: auto; /* Push frequency to the far right */
    margin-top: 0; /* Remove top margin */
  }

  .orgName {
    width: 286px; /* Restore width for mobile */
    margin-top: 0; /* Remove top margin for mobile */
  }

  .dropdown-container {
    padding-top: 20px;
  }
}
</style>
